// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2naGa","comment":"styles_comment__1AeJN"};